const RESIZE_DEBOUNCE_MS = 150;
const SCROLL_GAP_PX = 16;

const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const stickyHeaderHeight = () => document.querySelector('.site-header__new')?.offsetHeight ?? 0;

function initSingle(el) {
  const content = el.querySelector('[data-description-collapse-content]');
  const toggle = el.querySelector('[data-description-collapse-toggle]');

  if (!content || !toggle) {
    return;
  }

  const isExpanded = () => el.classList.contains('is-expanded');

  const update = () => {
    if (isExpanded()) {
      return;
    }

    const overflows = content.scrollHeight > content.clientHeight + 1;
    el.classList.toggle('is-collapsible', overflows);
    toggle.hidden = !overflows;
  };

  const expand = () => {
    el.classList.add('is-expanded');
    el.classList.remove('is-collapsible');
    toggle.setAttribute('aria-expanded', 'true');
  };

  // Bring the card top below the sticky header, but never scroll the focused toggle out of view.
  const scrollAfterCollapse = () => {
    const headerHeight = stickyHeaderHeight();
    const cardTop = el.getBoundingClientRect().top;

    if (cardTop >= headerHeight) {
      return;
    }

    const toggleBottom = toggle.getBoundingClientRect().bottom;
    const maxDelta = toggleBottom - window.innerHeight + SCROLL_GAP_PX;
    const delta = Math.max(cardTop - headerHeight - SCROLL_GAP_PX, maxDelta);

    window.scrollBy({
      top: delta,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
  };

  const collapse = () => {
    el.classList.remove('is-expanded');
    toggle.setAttribute('aria-expanded', 'false');
    update();
    scrollAfterCollapse();
  };

  toggle.addEventListener('click', () => (isExpanded() ? collapse() : expand()));

  // Keyboard users tabbing into a clipped link would otherwise focus something invisible.
  content.addEventListener('focusin', (event) => {
    if (
      !isExpanded()
      && el.classList.contains('is-collapsible')
      && event.target.matches(':focus-visible')
    ) {
      expand();
    }
  });

  let resizeTimeout = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(update, RESIZE_DEBOUNCE_MS);
  });
  window.addEventListener('load', update);

  update();
}

function init() {
  const els = document.querySelectorAll('[data-description-collapse]');
  [...els].forEach(initSingle);
}

export default {init};
